import { useRef, useState } from "react";
import AsyncSelect from "react-select/async";
import { Button } from "react-bootstrap";

import { CrearPersonaModal } from "./CrearPersonaModal";

const CREAR_OPTION = { id: "__crear__", label: "+ Crear nueva persona…", __crear__: true };

// Autocomplete de personas ya existentes en el sistema (busca por DNI/nombre/email)
// + un modal para cargar una persona nueva cuando no hay coincidencia. La persona
// solo se crea de verdad al enviar el formulario que contiene este picker.
export const PersonPicker = ({
  label,
  value,
  onChange,
  buscarUrl,
  showFecNac = false,
  required = false,
  error,
}) => {
  const [modalOpen, setModalOpen] = useState(false);
  const debounceRef = useRef(null);

  const loadOptions = (inputValue) =>
    new Promise((resolve) => {
      clearTimeout(debounceRef.current);
      const q = inputValue.trim();
      if (q.length < 2) {
        resolve([]);
        return;
      }
      debounceRef.current = setTimeout(async () => {
        try {
          const res = await fetch(`${buscarUrl}?q=${encodeURIComponent(q)}`);
          const data = await res.json();
          resolve([...data, CREAR_OPTION]);
        } catch (e) {
          resolve([CREAR_OPTION]);
        }
      }, 300);
    });

  const handleSelect = (option) => {
    if (!option) {
      onChange(null);
      return;
    }
    if (option.__crear__) {
      setModalOpen(true);
      return;
    }
    onChange({
      perfil_id: option.id,
      nombre: option.nombre,
      apellido: option.apellido,
      DNI: option.DNI,
      email: option.email,
      telefono: option.telefono,
      domicilio: option.domicilio,
      fecNac: null,
    });
  };

  const handleCrear = (data) => {
    setModalOpen(false);
    onChange(data);
  };

  return (
    <div className="mb-3">
      {label && (
        <label className="form-label">
          {label}
          {required && " *"}
        </label>
      )}

      {value ? (
        <div className="d-flex align-items-center gap-2 border rounded px-2 py-1">
          <span>
            {value.apellido}, {value.nombre}
            {value.DNI ? ` · DNI ${value.DNI}` : ""}
            {!value.perfil_id && (
              <span className="badge text-bg-secondary ms-2">nueva persona</span>
            )}
          </span>
          <Button size="sm" variant="link" onClick={() => onChange(null)}>
            Cambiar
          </Button>
        </div>
      ) : (
        <AsyncSelect
          key={buscarUrl}
          cacheOptions
          defaultOptions={[CREAR_OPTION]}
          loadOptions={loadOptions}
          onChange={handleSelect}
          getOptionValue={(o) => String(o.id)}
          getOptionLabel={(o) => o.label}
          placeholder="Buscar por nombre, apellido, DNI o email…"
          noOptionsMessage={() => "Escribí al menos 2 caracteres"}
        />
      )}

      {error && <div className="text-danger small mt-1">{error}</div>}

      <CrearPersonaModal
        show={modalOpen}
        onClose={() => setModalOpen(false)}
        onSave={handleCrear}
        showFecNac={showFecNac}
      />
    </div>
  );
};

export default PersonPicker;
